import { c as _c } from "react-compiler-runtime";
import { useState, useMemo, useRef, useEffect, useId } from 'react';
import { CellSelectionEffects } from '../../cellSelection/components/CellSelectionEffects';
import { Provider } from 'react-redux';
import { createStore } from '../../redux/createStore';
import { StoreContext } from '../../redux/storeContext';
import { createWidthsStore } from '../../redux/createWidthsStore';
import { createSelectionStore } from '../../redux/createSelectionStore';
import { createCellSelectionStore } from '../../redux/createCellSelectionStore';
import { WidthsStoreContext } from '../../redux/widthsStoreContext';
import { SelectionStoreContext } from '../../redux/selectionStoreContext';
import { ProvideCellSelection } from '../../cellSelection/context/CellSelectionContext';
import { EmptyComponent } from '../utils/EmptyComponent';
import { DEFAULT_PAGE_SIZES } from '../../pagination/constants/pageSizes';
import emptyFunction from 'react-utils/emptyFunction';
import Table from './Table';
import { ProvideAuth } from '../../auth/context/AuthContext';
import { DEFAULT_COLUMN_MINIMUM_WIDTH, DEFAULT_COLUMN_WIDTH, MINIMUM_RESIZABLE_COLUMN_WIDTH } from '../constants/sizes';
import { DefaultRowComponent } from './DefaultRowComponent';
import { DefaultTableComponent } from './DefaultTableComponent';
import { ProvideLogger } from '../../logger/context/LoggerContext';
import { ProvideFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { ProvideColumnCallToAction } from '../columnCallToAction/ColumnCallToActionContext';
import { useResolvedColumnCallToAction } from '../columnCallToAction/useResolvedColumnCallToAction';
import DefaultSelectAllComponent from '../../selection/components/DefaultSelectAllComponent';
import { ProvideVirtualization } from '../../virtualization/VirtualizationContext';
import { useAdjustCtaColumnWidth } from '../columnCallToAction/useAdjustCtaColumnWidth';
import { getColumnKey } from '../utils/getColumnKey';
import Raven from 'raven-js';
import { BulkActionsContainerAboveTable } from './BulkActionsContainerAboveTable';
import { infiniteScrollDisabled } from '../../infiniteScroll/config';
import { rightToolbarDisabled } from '../../rightToolbar/config';
import { cellSelectionDisabled, CELL_SELECTION_CONFIG_TYPES, isCellSelectionEnabled } from '../../cellSelection/config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const emptyArray = [];
const DEFAULT_NAMESPACE = 'DEFAULT_NAMESPACE';

//we explicitly prevent a column width of 0 - this || is weight bearing over ??
const getMinimumColumnWidth = column => Math.max(column.minimumColumnWidth || DEFAULT_COLUMN_MINIMUM_WIDTH,
// Below MINIMUM_RESIZABLE_COLUMN_WIDTH, users can no longer interact with column resizing and can get stuck with a too-narrow column
column.resizable ? MINIMUM_RESIZABLE_COLUMN_WIDTH : 0);
const TableWrapper = t0 => {
  const $ = _c(122);
  const {
    alternateHeaderLeftSlot: t1,
    BulkActionsComponent: t2,
    canSelectAllRecords: t3,
    columns,
    CustomSelectAllComponent: t4,
    disableScrollReset: t5,
    getRowId,
    hasGate,
    hasScope,
    headerLeftSlot: t6,
    headerRightSlot: t7,
    infiniteScrollConfig: t8,
    isBulkActionsRedesignEnabled: t9,
    isIndexRedesignEnabled: t10,
    loading: t11,
    logger: t12,
    noRowsSlot: t13,
    numberOfFrozenColumns: t14,
    onColumnOrderChange: t15,
    onColumnWidthChange: t16,
    contextMenuConfig,
    columnCallToAction,
    onPageIndexChange: t17,
    onPageSizeChange: t18,
    onSortsChange: t19,
    pageable: t20,
    pageIndex: t21,
    pageSize: t22,
    pageSizes: t23,
    paginatorAlignment: t24,
    reorderable: t25,
    resizable: t26,
    rows,
    RowComponent: t27,
    scrollContainerRef,
    selectable: t28,
    selectionStore: externalSelectionStore,
    cellSelectable: t29,
    cellSelectionConfig,
    sortable: t30,
    sorts: t31,
    TableComponent: t32,
    totalRowCount: t33,
    zebraStripe: t34,
    condensed: t35,
    dataDensity,
    enableFullVirtualization: t36,
    onFrozenColumnWidthAlert,
    hasTopBarBorderRadius,
    rightToolbarConfig: t37
  } = t0;
  const alternateHeaderLeftSlot = t1 === undefined ? null : t1;
  const BulkActionsComponent = t2 === undefined ? EmptyComponent : t2;
  const canSelectAllRecords = t3 === undefined ? true : t3;
  const CustomSelectAllComponent = t4 === undefined ? DefaultSelectAllComponent : t4;
  const disableScrollReset = t5 === undefined ? false : t5;
  const headerLeftSlot = t6 === undefined ? null : t6;
  const headerRightSlot = t7 === undefined ? null : t7;
  const infiniteScrollConfig = t8 === undefined ? infiniteScrollDisabled : t8;
  const isBulkActionsRedesignEnabled = t9 === undefined ? false : t9;
  const isIndexRedesignEnabled = t10 === undefined ? false : t10;
  const loading = t11 === undefined ? false : t11;
  const logger = t12 === undefined ? emptyFunction : t12;
  const noRowsSlot = t13 === undefined ? null : t13;
  const numberOfFrozenColumns = t14 === undefined ? 0 : t14;
  const onColumnOrderChange = t15 === undefined ? emptyFunction : t15;
  const onColumnWidthChange = t16 === undefined ? emptyFunction : t16;
  const onPageIndexChange = t17 === undefined ? emptyFunction : t17;
  const onPageSizeChange = t18 === undefined ? emptyFunction : t18;
  const onSortsChange = t19 === undefined ? emptyFunction : t19;
  const pageable = t20 === undefined ? true : t20;
  const pageIndex = t21 === undefined ? 0 : t21;
  const pageSize = t22 === undefined ? DEFAULT_PAGE_SIZES[0] : t22;
  const pageSizes = t23 === undefined ? DEFAULT_PAGE_SIZES : t23;
  const paginatorAlignment = t24 === undefined ? "center" : t24;
  const reorderable = t25 === undefined ? true : t25;
  const resizable = t26 === undefined ? true : t26;
  const RowComponent = t27 === undefined ? DefaultRowComponent : t27;
  const selectable = t28 === undefined ? true : t28;
  const cellSelectable = t29 === undefined ? false : t29;
  const sortable = t30 === undefined ? true : t30;
  const sorts = t31 === undefined ? emptyArray : t31;
  const TableComponent = t32 === undefined ? DefaultTableComponent : t32;
  const totalRowCount = t33 === undefined ? 0 : t33;
  const zebraStripe = t34 === undefined ? false : t34;
  const condensed = t35 === undefined ? true : t35;
  const enableFullVirtualization = t36 === undefined ? false : t36;
  const rightToolbarConfig = t37 === undefined ? rightToolbarDisabled : t37;
  const alreadyLoggedRavenRef = useRef(false);
  const fallbackScrollContainerRef = useRef(null);
  const effectiveScrollContainerRef = scrollContainerRef !== null && scrollContainerRef !== void 0 ? scrollContainerRef : fallbackScrollContainerRef;
  let t38;
  if ($[0] !== columns || $[1] !== reorderable || $[2] !== resizable || $[3] !== sortable) {
    let t39;
    if ($[5] !== reorderable || $[6] !== resizable || $[7] !== sortable) {
      t39 = column => {
        const minimumColumnWidth = getMinimumColumnWidth(column);
        const width = Math.max(column.width || DEFAULT_COLUMN_WIDTH, minimumColumnWidth);
        return Object.assign({}, column, {
          columnNamespace: column.columnNamespace || DEFAULT_NAMESPACE,
          width,
          minimumColumnWidth,
          resizable: column.resizable != null ? column.resizable : resizable,
          reorderable: column.reorderable != null ? column.reorderable : reorderable,
          sortable: column.sortable != null ? column.sortable : sortable
        });
      };
      $[5] = reorderable;
      $[6] = resizable;
      $[7] = sortable;
      $[8] = t39;
    } else {
      t39 = $[8];
    }
    t38 = columns.map(t39);
    $[0] = columns;
    $[1] = reorderable;
    $[2] = resizable;
    $[3] = sortable;
    $[4] = t38;
  } else {
    t38 = $[4];
  }
  const columnsWithDefaults = t38;
  let t39;
  let t40;
  if ($[9] !== columns) {
    t39 = () => {
      for (const column_0 of columns) {
        const minimumColumnWidth_0 = getMinimumColumnWidth(column_0);
        if (column_0.width && column_0.width < minimumColumnWidth_0) {
          const errorExtra = {
            columnName: column_0.columnName,
            columnNamespace: column_0.columnNamespace,
            width: column_0.width,
            minimumColumnWidth: minimumColumnWidth_0
          };
          console.error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users.", errorExtra);
          if (!alreadyLoggedRavenRef.current) {
            Raven.captureException(new Error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users."), {
              extra: {
                errorExtra
              }
            });
            alreadyLoggedRavenRef.current = true;
          }
        }
      }
    };
    t40 = [columns];
    $[9] = columns;
    $[10] = t39;
    $[11] = t40;
  } else {
    t39 = $[10];
    t40 = $[11];
  }
  useEffect(t39, t40);
  let t41;
  if ($[12] !== columnsWithDefaults) {
    t41 = () => createWidthsStore({
      initialWidths: columnsWithDefaults.reduce(_temp, {})
    });
    $[12] = columnsWithDefaults;
    $[13] = t41;
  } else {
    t41 = $[13];
  }
  const [widthsStore] = useState(t41);
  let t42;
  if ($[14] !== columnCallToAction || $[15] !== columnsWithDefaults || $[16] !== widthsStore) {
    t42 = {
      columnCallToAction,
      columnsWithDefaults,
      widthsStore
    };
    $[14] = columnCallToAction;
    $[15] = columnsWithDefaults;
    $[16] = widthsStore;
    $[17] = t42;
  } else {
    t42 = $[17];
  }
  useAdjustCtaColumnWidth(t42);
  let t43;
  if ($[18] !== externalSelectionStore) {
    t43 = () => externalSelectionStore ? null : createSelectionStore();
    $[18] = externalSelectionStore;
    $[19] = t43;
  } else {
    t43 = $[19];
  }
  const [internalSelectionStore] = useState(t43);
  const selectionStore = externalSelectionStore !== null && externalSelectionStore !== void 0 ? externalSelectionStore : internalSelectionStore;
  const [cellSelectionStore] = useState(_temp2);
  const cellSelectionScopeId = useId();
  let t44;
  if ($[20] !== cellSelectable || $[21] !== cellSelectionConfig) {
    t44 = cellSelectionConfig !== null && cellSelectionConfig !== void 0 ? cellSelectionConfig : cellSelectable ? {
      type: CELL_SELECTION_CONFIG_TYPES.CELL_SELECTION_ENABLED
    } : cellSelectionDisabled;
    $[20] = cellSelectable;
    $[21] = cellSelectionConfig;
    $[22] = t44;
  } else {
    t44 = $[22];
  }
  const resolvedCellSelectionConfig = t44;
  let t45;
  if ($[23] !== resolvedCellSelectionConfig) {
    t45 = isCellSelectionEnabled(resolvedCellSelectionConfig);
    $[23] = resolvedCellSelectionConfig;
    $[24] = t45;
  } else {
    t45 = $[24];
  }
  const cellSelectionEnabled = t45;
  const [store] = useState(_temp3);
  let t46;
  if ($[25] !== sorts) {
    t46 = sorts.map(_temp4);
    $[25] = sorts;
    $[26] = t46;
  } else {
    t46 = $[26];
  }
  const sortsWithDefaults = t46;
  const shouldShowBulkActionsContainerAboveTable = isBulkActionsRedesignEnabled && isIndexRedesignEnabled;
  let t47;
  if ($[27] !== columnCallToAction || $[28] !== columnsWithDefaults || $[29] !== numberOfFrozenColumns || $[30] !== rows) {
    t47 = {
      columnCallToAction,
      columnsWithDefaults,
      rows,
      numberOfFrozenColumns
    };
    $[27] = columnCallToAction;
    $[28] = columnsWithDefaults;
    $[29] = numberOfFrozenColumns;
    $[30] = rows;
    $[31] = t47;
  } else {
    t47 = $[31];
  }
  const resolvedColumnCallToAction = useResolvedColumnCallToAction(t47);
  let t48;
  if ($[32] !== cellSelectionEnabled || $[33] !== columnsWithDefaults || $[34] !== effectiveScrollContainerRef || $[35] !== getRowId || $[36] !== rows) {
    t48 = cellSelectionEnabled && /*#__PURE__*/_jsx(CellSelectionEffects, {
      columns: columnsWithDefaults,
      rows: rows,
      getRowId: getRowId,
      scrollContainerRef: effectiveScrollContainerRef
    });
    $[32] = cellSelectionEnabled;
    $[33] = columnsWithDefaults;
    $[34] = effectiveScrollContainerRef;
    $[35] = getRowId;
    $[36] = rows;
    $[37] = t48;
  } else {
    t48 = $[37];
  }
  let t49;
  if ($[38] !== BulkActionsComponent || $[39] !== canSelectAllRecords || $[40] !== getRowId || $[41] !== isBulkActionsRedesignEnabled || $[42] !== isIndexRedesignEnabled || $[43] !== rows || $[44] !== shouldShowBulkActionsContainerAboveTable || $[45] !== totalRowCount) {
    t49 = shouldShowBulkActionsContainerAboveTable && /*#__PURE__*/_jsx(BulkActionsContainerAboveTable, {
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      getRowId: getRowId,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      rows: rows,
      totalRowCount: totalRowCount
    });
    $[38] = BulkActionsComponent;
    $[39] = canSelectAllRecords;
    $[40] = getRowId;
    $[41] = isBulkActionsRedesignEnabled;
    $[42] = isIndexRedesignEnabled;
    $[43] = rows;
    $[44] = shouldShowBulkActionsContainerAboveTable;
    $[45] = totalRowCount;
    $[46] = t49;
  } else {
    t49 = $[46];
  }
  let t50;
  if ($[47] !== BulkActionsComponent || $[48] !== CustomSelectAllComponent || $[49] !== RowComponent || $[50] !== TableComponent || $[51] !== alternateHeaderLeftSlot || $[52] !== canSelectAllRecords || $[53] !== columnsWithDefaults || $[54] !== condensed || $[55] !== dataDensity || $[56] !== disableScrollReset || $[57] !== effectiveScrollContainerRef || $[58] !== enableFullVirtualization || $[59] !== getRowId || $[60] !== hasTopBarBorderRadius || $[61] !== headerLeftSlot || $[62] !== headerRightSlot || $[63] !== infiniteScrollConfig || $[64] !== isBulkActionsRedesignEnabled || $[65] !== isIndexRedesignEnabled || $[66] !== loading || $[67] !== noRowsSlot || $[68] !== numberOfFrozenColumns || $[69] !== onColumnOrderChange || $[70] !== onColumnWidthChange || $[71] !== onFrozenColumnWidthAlert || $[72] !== onPageIndexChange || $[73] !== onPageSizeChange || $[74] !== onSortsChange || $[75] !== pageIndex || $[76] !== pageSize || $[77] !== pageSizes || $[78] !== pageable || $[79] !== paginatorAlignment || $[80] !== reorderable || $[81] !== resizable || $[82] !== rightToolbarConfig || $[83] !== rows || $[84] !== selectable || $[85] !== sortable || $[86] !== sortsWithDefaults || $[87] !== totalRowCount || $[88] !== zebraStripe) {
    t50 = /*#__PURE__*/_jsx(Table, {
      alternateHeaderLeftSlot: alternateHeaderLeftSlot,
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      scrollContainerRef: effectiveScrollContainerRef,
      columns: columnsWithDefaults,
      condensed: condensed,
      dataDensity: dataDensity,
      CustomSelectAllComponent: CustomSelectAllComponent,
      disableScrollReset: disableScrollReset,
      enableFullVirtualization: enableFullVirtualization,
      getRowId: getRowId,
      headerLeftSlot: headerLeftSlot,
      headerRightSlot: headerRightSlot,
      infiniteScrollConfig: infiniteScrollConfig,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      loading: loading,
      noRowsSlot: noRowsSlot,
      numberOfFrozenColumns: numberOfFrozenColumns,
      onColumnOrderChange: onColumnOrderChange,
      onColumnWidthChange: onColumnWidthChange,
      onFrozenColumnWidthAlert: onFrozenColumnWidthAlert,
      onPageIndexChange: onPageIndexChange,
      onPageSizeChange: onPageSizeChange,
      onSortsChange: onSortsChange,
      pageable: pageable,
      pageIndex: pageIndex,
      pageSize: pageSize,
      pageSizes: pageSizes,
      paginatorAlignment: paginatorAlignment,
      reorderable: reorderable,
      resizable: resizable,
      RowComponent: RowComponent,
      rows: rows,
      selectable: selectable,
      sorts: sortsWithDefaults,
      sortable: sortable,
      TableComponent: TableComponent,
      totalRowCount: totalRowCount,
      zebraStripe: zebraStripe,
      hasTopBarBorderRadius: hasTopBarBorderRadius,
      rightToolbarConfig: rightToolbarConfig
    });
    $[47] = BulkActionsComponent;
    $[48] = CustomSelectAllComponent;
    $[49] = RowComponent;
    $[50] = TableComponent;
    $[51] = alternateHeaderLeftSlot;
    $[52] = canSelectAllRecords;
    $[53] = columnsWithDefaults;
    $[54] = condensed;
    $[55] = dataDensity;
    $[56] = disableScrollReset;
    $[57] = effectiveScrollContainerRef;
    $[58] = enableFullVirtualization;
    $[59] = getRowId;
    $[60] = hasTopBarBorderRadius;
    $[61] = headerLeftSlot;
    $[62] = headerRightSlot;
    $[63] = infiniteScrollConfig;
    $[64] = isBulkActionsRedesignEnabled;
    $[65] = isIndexRedesignEnabled;
    $[66] = loading;
    $[67] = noRowsSlot;
    $[68] = numberOfFrozenColumns;
    $[69] = onColumnOrderChange;
    $[70] = onColumnWidthChange;
    $[71] = onFrozenColumnWidthAlert;
    $[72] = onPageIndexChange;
    $[73] = onPageSizeChange;
    $[74] = onSortsChange;
    $[75] = pageIndex;
    $[76] = pageSize;
    $[77] = pageSizes;
    $[78] = pageable;
    $[79] = paginatorAlignment;
    $[80] = reorderable;
    $[81] = resizable;
    $[82] = rightToolbarConfig;
    $[83] = rows;
    $[84] = selectable;
    $[85] = sortable;
    $[86] = sortsWithDefaults;
    $[87] = totalRowCount;
    $[88] = zebraStripe;
    $[89] = t50;
  } else {
    t50 = $[89];
  }
  let t51;
  if ($[90] !== cellSelectionScopeId || $[91] !== cellSelectionStore || $[92] !== resolvedCellSelectionConfig || $[93] !== t48 || $[94] !== t49 || $[95] !== t50) {
    t51 = /*#__PURE__*/_jsxs(ProvideCellSelection, {
      config: resolvedCellSelectionConfig,
      store: cellSelectionStore,
      scopeId: cellSelectionScopeId,
      children: [t48, t49, t50]
    });
    $[90] = cellSelectionScopeId;
    $[91] = cellSelectionStore;
    $[92] = resolvedCellSelectionConfig;
    $[93] = t48;
    $[94] = t49;
    $[95] = t50;
    $[96] = t51;
  } else {
    t51 = $[96];
  }
  let t52;
  if ($[97] !== store || $[98] !== t51) {
    t52 = /*#__PURE__*/_jsx(Provider, {
      store: store,
      context: StoreContext,
      children: t51
    });
    $[97] = store;
    $[98] = t51;
    $[99] = t52;
  } else {
    t52 = $[99];
  }
  let t53;
  if ($[100] !== selectionStore || $[101] !== t52) {
    t53 = /*#__PURE__*/_jsx(Provider, {
      store: selectionStore,
      context: SelectionStoreContext,
      children: t52
    });
    $[100] = selectionStore;
    $[101] = t52;
    $[102] = t53;
  } else {
    t53 = $[102];
  }
  let t54;
  if ($[103] !== t53 || $[104] !== widthsStore) {
    t54 = /*#__PURE__*/_jsx(Provider, {
      store: widthsStore,
      context: WidthsStoreContext,
      children: t53
    });
    $[103] = t53;
    $[104] = widthsStore;
    $[105] = t54;
  } else {
    t54 = $[105];
  }
  let t55;
  if ($[106] !== resolvedColumnCallToAction || $[107] !== t54) {
    t55 = /*#__PURE__*/_jsx(ProvideColumnCallToAction, {
      value: resolvedColumnCallToAction,
      children: t54
    });
    $[106] = resolvedColumnCallToAction;
    $[107] = t54;
    $[108] = t55;
  } else {
    t55 = $[108];
  }
  let t56;
  if ($[109] !== contextMenuConfig || $[110] !== t55) {
    t56 = /*#__PURE__*/_jsx(ProvideFDTContextMenuConfig, {
      contextMenuConfig: contextMenuConfig,
      children: t55
    });
    $[109] = contextMenuConfig;
    $[110] = t55;
    $[111] = t56;
  } else {
    t56 = $[111];
  }
  let t57;
  if ($[112] !== enableFullVirtualization || $[113] !== t56) {
    t57 = /*#__PURE__*/_jsx(ProvideVirtualization, {
      enableFullVirtualization: enableFullVirtualization,
      children: t56
    });
    $[112] = enableFullVirtualization;
    $[113] = t56;
    $[114] = t57;
  } else {
    t57 = $[114];
  }
  let t58;
  if ($[115] !== logger || $[116] !== t57) {
    t58 = /*#__PURE__*/_jsx(ProvideLogger, {
      logger: logger,
      children: t57
    });
    $[115] = logger;
    $[116] = t57;
    $[117] = t58;
  } else {
    t58 = $[117];
  }
  let t59;
  if ($[118] !== hasGate || $[119] !== hasScope || $[120] !== t58) {
    t59 = /*#__PURE__*/_jsx(ProvideAuth, {
      hasScope: hasScope,
      hasGate: hasGate,
      children: t58
    });
    $[118] = hasGate;
    $[119] = hasScope;
    $[120] = t58;
    $[121] = t59;
  } else {
    t59 = $[121];
  }
  return t59;
};
export default TableWrapper;
function _temp(acc, column_1) {
  const width_0 = column_1.width || DEFAULT_COLUMN_WIDTH;
  acc[getColumnKey(column_1.columnNamespace || DEFAULT_NAMESPACE, column_1.columnName)] = width_0;
  return acc;
}
function _temp2() {
  return createCellSelectionStore();
}
function _temp3() {
  return createStore();
}
function _temp4(sort) {
  return Object.assign({}, sort, {
    columnNamespace: sort.columnNamespace != null ? sort.columnNamespace : DEFAULT_NAMESPACE
  });
}